import React from "react";

export default function ReportExportActionsColumn({ children }) {
  return <div className="reports-export-actions-column">{children}</div>;
}
